import { WhatIfSummaryPage } from '@/pages/what-if/summary'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_app/p/whatif/runs/$scenarioRunSetId/summary'
)({
	component: WhatIfSummaryPage,
})
